export default class AttachmentHelper {
	/**
	 *
	 * @param {object} attachment
	 */
	static isPdf(attachment) {
		return attachment.file_type === 'PDF' || attachment.content_type === 'application/pdf' || attachment.content_type === 'application/octet-stream';
	}

	/**
	 *
	 * @param {object} attachment
	 */
	static isXml(attachment) {
		return attachment.content_type === 'text/xml' || attachment.content_type === 'application/xml' || attachment.file_type === 'XML';
	}

	// To make downloading attachments work  ¯\_(ツ)_/¯
	static base64ToArrayBuffer(_base64Str) {
		let binaryString = window.atob(_base64Str);
		let binaryLen = binaryString.length;
		let bytes = new Uint8Array(binaryLen);
		for (let i = 0; i < binaryLen; i++) {
			let ascii = binaryString.charCodeAt(i);
			bytes[i] = ascii;
		}
		return bytes;
	}

	static showDocument(_base64Str, _contentType) {
		let byte = AttachmentHelper.base64ToArrayBuffer(_base64Str);
		let blob = new Blob([byte], { type: _contentType });
		window.open(URL.createObjectURL(blob), '_blank');
	}
}
